import type { BaseUrl, IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import fetchSubtasks from './utils.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: BaseUrl, parentId: IssueId) =>
	fetchSubtasks(baseUrl, parentId).then((response) => {
		const fields = response && response.fields;
		return (fields && fields.subtasks) || [];
	});
